import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaMobileAlt,
  FaBrain,
  FaPaintBrush,
  FaCode,
  FaShoppingCart,
  FaCloud,
  FaBullhorn,
  FaArrowRight,
} from 'react-icons/fa';
import classes from './Services.module.scss';

import mobileAppImg from '../../assets/app_dev_service.png';
import aiMlImg from '../../assets/ai_ml_service.png';
import uiUxImg from '../../assets/ui_ux_service.png';
import webDevImg from '../../assets/web_dev_service.png';
import ecommerceImg from '../../assets/ecommerce_dev_service.png';
import cloudImg from '../../assets/cloud_devops_service.png';

const services = [
  {
    icon: <FaMobileAlt />,
    title: 'Mobile App Development',
    description:
      'Native and cross-platform mobile apps built for performance, engagement, and scale — from MVP to enterprise.',
    highlights: ['iOS & Android', 'React Native / Flutter', 'Push & Analytics'],
    image: mobileAppImg,
    link: '/services/mobile-app-development',
    accent: '#6366f1',
  },
  {
    icon: <FaBrain />,
    title: 'AI / ML Solutions',
    description:
      'Turn raw data into business intelligence with custom machine learning models, NLP, and predictive analytics.',
    highlights: ['Custom ML Models', 'NLP & Chatbots', 'Computer Vision'],
    image: aiMlImg,
    link: '/services/ai-ml-development',
    accent: '#8b5cf6',
  },
  {
    icon: <FaPaintBrush />,
    title: 'UI / UX Design',
    description:
      'User-centred interfaces that are beautiful, intuitive, and conversion-focused — designed to delight.',
    highlights: ['User Research', 'Wireframes & Prototypes', 'Design Systems'],
    image: uiUxImg,
    link: '/services/ui-ux-design',
    accent: '#ec4899',
  },
  {
    icon: <FaCode />,
    title: 'Web Development',
    description:
      'High-performance websites and web portals with clean architecture, SEO, and blazing-fast load times.',
    highlights: ['React / Next.js', 'SEO Optimized', 'Responsive & Fast'],
    image: webDevImg,
    link: '/services/web-development',
    accent: '#3b82f6',
  },
  {
    icon: <FaShoppingCart />,
    title: 'E-commerce Development',
    description:
      'Scalable online stores with secure payments, inventory management, and seamless checkout experiences.',
    highlights: ['Payment Gateways', 'Inventory System', 'Shopify / Custom'],
    image: ecommerceImg,
    link: '/services/ecommerce-development',
    accent: '#f59e0b',
  },
  {
    icon: <FaCloud />,
    title: 'Cloud & DevOps',
    description:
      'Cloud architecture, CI/CD pipelines, and infrastructure that scales automatically and stays reliable.',
    highlights: ['AWS / GCP / Azure', 'CI/CD Pipelines', 'Auto-scaling'],
    image: cloudImg,
    link: '/services/cloud-devops-infrastructure',
    accent: '#06b6d4',
  },
  {
    icon: <FaBullhorn />,
    title: 'Digital Marketing',
    description:
      'Data-driven marketing strategies — SEO, paid ads, social media, and content that drives real results.',
    highlights: ['SEO & SEM', 'Social Media', 'Analytics & ROI'],
    image: webDevImg,
    link: '/services/digital-marketing',
    accent: '#10b981',
  },
];

const Services = () => {
  return (
    <section id="services" className={classes.services}>
      <div className={classes.container}>
        {/* Header */}
        <div className={classes.header}>
          <span className={classes.badge}>What We Do</span>
          <h2 className={classes.title}>
            Services Built to{' '}
            <span className={classes.gradient}>Grow Your Business</span>
          </h2>
          <p className={classes.subtitle}>
            From concept to deployment, we deliver end-to-end digital solutions
            that are engineered for performance and designed for people.
          </p>
        </div>

        {/* Services grid */}
        <div className={classes.grid}>
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className={classes.card}
              style={{ '--card-accent': service.accent }}
            >
              {/* Card top: icon + text */}
              <div className={classes.cardTop}>
                <div className={classes.iconCircle}>{service.icon}</div>
                <h3 className={classes.cardTitle}>{service.title}</h3>
                <p className={classes.cardDesc}>{service.description}</p>
              </div>

              {/* Highlights */}
              <div className={classes.highlights}>
                {service.highlights.map((h, i) => (
                  <span key={i} className={classes.chip}>
                    {h}
                  </span>
                ))}
              </div>

              {/* Image */}
              <div className={classes.imageWrap}>
                <img src={service.image} alt={service.title} />
              </div>

              {/* Footer CTA */}
              <div className={classes.cardFooter}>
                <span>Explore Service</span>
                <FaArrowRight className={classes.arrow} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
